const splitWidget = document.querySelectorAll('.wt-Split');
window.fireOnVisible(splitWidget, async (elem) => {
    await import('./assets/css/split.scss');
});
